import config from './config/environment';

const HOST = config.API_BASE_URL

export const ENDPOINT_AUTH = HOST + "/v1/auth"
export const ENDPOINT_AUTH_COM = HOST + "/v1/auth/com"
export const ENDPOINT_FORGOT_PASS = HOST + "/v1/auth/forgot"
export const ENDPOINT_SIGNOUT = HOST + "/v1/auth/signout"
export const ENDPOINT_AUTOLOGIN = HOST + "/v1/auth/autologin"
export const ENDPOINT_REG = HOST + "/v1/reg"
export const ENDPOINT_LANDING_ICON = HOST + "/v1/app/iconl"
export const ENDPOINT_AUTH_DETAILS = HOST + "/v1/auth/details"
export const ENDPOINT_PASSPORT_COM = HOST + "/v1/session/com"
export const ENDPOINT_AUTH_REAUTHORIZE = HOST + "/v1/auth/reauth"
export const ENDPOINT_AUTH_MFA = HOST + "/v1/auth/mfa"
export const ENDPOINT_REAUTH_PASSKEY_BEGIN = HOST + "/v1/auth/reauth/passkey/begin"
export const ENDPOINT_PASSPORT_COM_GET = HOST + "/v1/ses/com/ret"

export const ENDPOINT_INVITE = HOST + "/v1/invite"
export const ENDPOINT_INVITE_ACCEPT = HOST + "/v1/invite/accept"
export const ENDPOINT_INVITE_DETAILS = HOST + "/v1/invite/details"
export const ENDPOINT_USERS = HOST + "/v1/users"
export const ENDPOINT_USER_UPDATE = HOST + "/v1/user/update"
export const ENDPOINT_USER_ROLE = HOST + "/v1/users/role/update"
export const ENDPOINT_USER_RETRIEVE_ROLES = HOST + "/v1/users/role"
export const ENDPOINT_UPLOAD_PROFILE = HOST + "/v1/profile/upload"
export const ENDPOINT_UPDATE_INVITE_PREF = HOST + "/v1/invite/pref"
export const ENDPOINT_ADMIN_USER_RESET = HOST + "/v1/users/reset" // resets user from blocked status
export const ENDPOINT_USER_REMOVE_COMPANY_ACCESS = HOST + "/v1/user/company/remove" // remove all user app access from company

export const ENDPOINT_APP_ADD = HOST + "/v1/apps/add"
export const ENDPOINT_APP_REMOVE = HOST + "/v1/apps/remove"
export const ENDPOINT_APP_UPDATE = HOST + "/v1/apps/update"
export const ENDPOINT_APPS = HOST + "/v1/apps"
export const ENDPOINT_CLIENTS = HOST + "/v1/clients"
export const ENDPOINT_CLIENT_ADD = HOST + "/v1/client/add"
export const ENDPOINT_CLIENT_UPDATE = HOST + "/v1/client/update"
export const ENDPOINT_CLIENT_REMOVE = HOST + "/v1/client/remove"
export const ENDPOINT_APP_ICON = HOST + "/v1/apps/icon"

// ROLES
export const ENDPOINT_ROLES = HOST + "/v1/roles"
export const ENDPOINT_REMOVE_ROLE = HOST + "/v1/role/remove"
export const ENDPOINT_ADD_ROLE = HOST + "/v1/role/add"
export const ENDPOINT_UPDATE_ROLE = HOST + "/v1/role/update"

// companies
export const ENDPOINT_COMS = HOST + "/v1/coms"
export const ENDPOINT_COM_DETAILS = HOST + "/v1/com/details"
export const ENDPOINT_COM_DETAILS_IMG = HOST + "/v1/com/img"
export const ENDPOINT_COM_ADD = HOST + "/v1/com/add"
export const ENDPOINT_COM_REMOVE = HOST + "/v1/com/remove"
export const ENDPOINT_COM_UPDATE = HOST + "/v1/com/update"
export const ENDPOINT_COM_INVITE = HOST + "/v1/com/invite"

// Device Approval Endpoints for Companies
export const ENDPOINT_COM_DEVICE_APPROVAL = HOST + "/v1/com/device-approval"
export const ENDPOINT_COM_DEVICE_REQUESTS = HOST + "/v1/com/device-requests"
export const ENDPOINT_COM_DEVICE_REQUEST_ACTION = HOST + "/v1/com/device-request/action"
export const ENDPOINT_COM_ALLOWED_DEVICES = HOST + "/v1/com/allowed-devices"

// Company IP Whitelist Endpoints
export const ENDPOINT_COM_IP_WHITELIST = HOST + "/v1/com/ip-whitelist"
export const ENDPOINT_COM_IP_WHITELIST_TOGGLE = HOST + "/v1/com/ip-whitelist/toggle"
export const ENDPOINT_COM_IP_WHITELIST_REQUEST_OTP = HOST + "/v1/com/ip-whitelist/request-otp"
export const ENDPOINT_COM_IP_WHITELIST_ADD = HOST + "/v1/com/ip-whitelist/add"
export const ENDPOINT_COM_IP_WHITELIST_REMOVE = HOST + "/v1/com/ip-whitelist/remove"

// Force delete (core1 only, password + OTP gated)
export const ENDPOINT_USER_FORCE_DELETE_REQUEST_OTP = HOST + "/v1/user/force-delete/request-otp"
export const ENDPOINT_USER_FORCE_DELETE = HOST + "/v1/user/force-delete"

// Cross-company user browsing (core1 owner only, password + OTP gated)
export const ENDPOINT_COM_CROSS_BROWSE_REQUEST_OTP = HOST + "/v1/com/cross-browse/request-otp"
export const ENDPOINT_COM_CROSS_BROWSE_TOGGLE = HOST + "/v1/com/cross-browse/toggle"

// subscriptions
export const ENDPOINT_SUBS_RETRIEVE = HOST + "/v1/subs"
export const ENDPOINT_SUBS_UPDATE = HOST + "/v1/subs/update"

// branches
export const ENDPOINT_BRANCHES_RETRIEVE = HOST + "/v1/branches"
export const ENDPOINT_BRANCH_ADD = HOST + "/v1/branch/add"
export const ENDPOINT_BRANCH_REMOVE = HOST + "/v1/branch/remove"
export const ENDPOINT_BRANCH_UPDATE = HOST + "/v1/branch/update"
export const ENDPOINT_USER_BRANCH_RETRIEVE = HOST + "/v1/user/branch"
export const ENDPOINT_USER_BRANCH_ADD = HOST + "/v1/user/branch/add"
export const ENDPOINT_USER_BRANCH_REMOVE = HOST + "/v1/user/branch/remove"


export const ENDPOINT_FORGOT_REQUEST = HOST + "/v1/forgot/request"
export const ENDPOINT_FORGOT_VALIDATE = HOST + "/v1/forgot/validate"
export const ENDPOINT_FORGOT_UPDATE = HOST + "/v1/forgot/update"

// Devices endpoint 
export const ENDPOINT_DEVICES = HOST + "/v1/devices"
export const ENDPOINT_DEVICE_REMOVE = HOST + "/v1/device/remove"
export const ENDPOINT_DEVICE_VERIFY = HOST + "/v1/device/verify"
export const ENDPOINT_DEVICE_STATUS = HOST + "/v1/device/status" // Endpoint for changing device status

// Password Change Endpoints
export const ENDPOINT_USER_REQUEST_PASSWORD_OTP = HOST + "/v1/user/pass/request-otp"
export const ENDPOINT_USER_VERIFY_PASSWORD_OTP = HOST + "/v1/user/pass/verify-otp"
export const ENDPOINT_USER_CONFIRM_PASSWORD_CHANGE = HOST + "/v1/user/pass/confirm"
export const ENDPOINT_USER_DELETE_SELF = HOST + "/v1/user/delete/self"
export const ENDPOINT_USER_SECURITY_ACTIVITY = HOST + "/v1/user/security/activity"

// MFA Endpoints
export const ENDPOINT_MFA_SETTINGS_GET = HOST + "/v1/mfa/settings";
export const ENDPOINT_MFA_SETTINGS_UPDATE = HOST + "/v1/mfa/settings/update";
export const ENDPOINT_MFA_PIN_SET = HOST + "/v1/mfa/pin/set";

// Passkey Endpoints
export const ENDPOINT_MFA_PASSKEY_REGISTER_BEGIN = HOST + "/v1/mfa/passkey/register/begin";
export const ENDPOINT_MFA_PASSKEY_REGISTER_FINISH = HOST + "/v1/mfa/passkey/register/finish";
export const ENDPOINT_MFA_PASSKEY_AUTH_BEGIN = HOST + "/v1/mfa/passkey/auth/begin";
export const ENDPOINT_MFA_PASSKEY_AUTH_FINISH = HOST + "/v1/mfa/passkey/auth/finish";
export const ENDPOINT_MFA_PASSKEY_LIST = HOST + "/v1/mfa/passkey/list";
export const ENDPOINT_MFA_PASSKEY_DELETE = HOST + "/v1/mfa/passkey/delete";

// Notifications
export const ENDPOINT_NOTIFICATIONS = HOST + "/v1/notifications";
export const ENDPOINT_NOTIFICATION_READ = HOST + "/v1/notification/read";
export const ENDPOINT_NOTIFICATIONS_READ_ALL = HOST + "/v1/notifications/read-all";
export const ENDPOINT_NOTIFICATIONS_UNREAD_COUNT = HOST + "/v1/notifications/unread-count";

export const ERR_FORGOT_INVALID = "forgot_invalid" // forgot code is invalid
export const ERR_FORGOT_USED = "forgot_used"       // forgot code was already used
export const ERR_FORGOT_EXPIRED = "forgot_expired" // forgot code was already expired
export const ERR_ACCESS_DENIED = "access_not_found" // access denied
export const ERR_AUTH_INVALID = "auth_invalid" // auth code is invalid
export const ERR_SESSION_EXPIRED = "session_expired"
export const ERR_UNAUTHORIZED_DEVICE = "unauthorized_device" // maybe the device was blocked
export const ERR_ACC_BLOCKED = "account_blocked"
export const ERR_ACCESS_UNVERIFIED = "access_unverified"         // use access is not yet verified. user should accept it first
export const ERR_IP_BANNED = "credential_stuffing_detected"
export const ERR_SESSION_INVALID = "session_invalid"
export const ERR_COOKIE = "cookie_err"
export const ERR_INVALID_PASS = "pass_invalid" // Invalid password
export const ERR_ACCOUNT_FAILED = "account_failed" // Account failed login attempts
export const ERR_AWAITING_RESET = "account_awaiting_reset" // Account is awaiting reset
export const ERR_INVALID_CRED = "invalid_credentials"
export const ERR_DEVICE_NOT_FOUND = "device_not_found" // Device not found
export const ERR_DEVICE_USER_MISMATCH = "device_user_mismatch" // Device does not belong to user
export const ERR_DEVICE_APPROVAL_PENDING = "device_approval_pending" // Device is pending approval
export const ERR_DEVICE_APPROVAL_REJECTED = "device_approval_rejected" // Device approval was rejected
export const ERR_RATE_LIMIT = "rate_limit_exceeded" // Too many requests from IP address
export const ERR_INVALID_PIN = "invalid_pin" // Invalid PIN for MFA
export const USER_NOT_FOUND = "user_not_found"
export const APP_NOT_EXIST = "app_not_exist"
export const ERR_DATA = "data_error"
export const ERR_INTERNAL = "internal_error"
export const CALLBACK_NOT_SET = "callback_invalid"
export const HTTP_OK = "200"
export const ERR_APP_ACCESS_PROHIBITED = "app_access_prohibited" // company is not allowed to access app
export const ERR_APP_DISABLED = "app_disabled"
export const ERR_DEVICE_ADD = "device_add"
export const ERR_MFA_REQUIRED = "mfa_required"
export const ERR_MAX_DEVICE_REACHED = "device_limit_reached"
export const ERR_INVALID_DEVICE_TYPE = "device_type_invalid"
export const ERR_IP_NOT_WHITELISTED = "ip_not_whitelisted"
export const ERR_FAILED_GET_COMPANIES = "failed_get_companies"

export const OWNER_ROLE = config.OWNER_ROLE
export const ADMIN_ROLE = config.ADMIN_ROLE
export const SUPPORT_ROLE = "global.support"
export const GLOBAL_APP = config.GLOBAL_APP
export const CORE1_COM = config.CORE1_COM
export const BUNDLE_ID = config.BUNDLE_ID
export const CLIENT_ID = config.CLIENT_ID

// Users (not access records) listed per page. Must match utils.USERS_PAGE_SIZE on the backend
export const USERS_PAGE_SIZE = 30

// User Status Strings (must match backend)
export const USER_ACTIVE_STATUS_STRING = "active";
export const USER_BLOCKED_STATUS_STRING = "blocked";
export const USER_STATUS_AWAITING_RESET_STRING = "awaiting_reset";

// IP Management Endpoints
export const ENDPOINT_IP_WHITELIST = HOST + "/v1/admin/ip/whitelist"
export const ENDPOINT_IP_WHITELIST_ADD = HOST + "/v1/admin/ip/whitelist/add"
export const ENDPOINT_IP_WHITELIST_REMOVE = HOST + "/v1/admin/ip/whitelist/remove"
export const ENDPOINT_IP_BANNED = HOST + "/v1/admin/ip/banned"
export const ENDPOINT_IP_BANNED_UNBAN = HOST + "/v1/admin/ip/banned/unban"
export const ENDPOINT_IP_BANNED_ADD = HOST + "/v1/admin/ip/banned/add"
